import zhlocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  'index': {
    'Projects': '项目',
    'Open': '活跃',
    'Closed': '已关闭',
    'NewProject': '创建项目',
    'SearchProjectNameOrAddress': '搜索项目名称或地址',
    'Filters': '筛选',
    'Updated': '更新:{date}',
    'NoData': '无数据',
    'Name': '名称',
    'User': '用户',
    'CreatedFrom': '创建时间(从)',
    'CreatedTo': '创建时间(到)',
    'daysAgo': ' 天前',
    'hoursAgo': ' 小时前',
    'minutesAgo': ' 分钟前',
    'CreateBy': '创建人',
    'Members': '项目成员',
    'Tutorials': '教程',
    'DownloadApp': '下载 App'
  },
  '404': {
    'OOPS': '哎呀！',
    'ThePageYouWereLookingForIsMissing': '您查看的页面找不到了',
    'check': '请检查您输入的网址是否正确，点击下面的按钮返回',
    'Back': '返回'
  },
  'corp': {
    'ExpiredOn': '到期时间',
    'Corp': '公司',
    'Paid in Apple': '苹果支付',
    'total': '总计',
    'ConfigLanguage': '设置语言',
    'User': '人',
    'PaymentMethod': '支付方式',
    'Type': '类型',
    'Chinese': '中文',
    'English': '英文',
    'BatchDelete': '批量删除',
    'Welcome': '欢迎, {user}',
    'EditCorp': '编辑公司',
    'CategoryName': '类别名称',
    'Action': '操作',
    'Edit': '编辑',
    'Settings': '设置',
    'CompanyName': '公司名称',
    'CorpSetting': '公司设置',
    'M2Integration': '集成M2',
    'Unit': '单位',
    'TemperatureUnit': '温度单位',
    'Categories': '类别',
    'Save': '保存',
    'LaborItems': '劳务项',
    'NewLaborItem': '创建劳务项',
    'Name': '名称',
    'InstallCarpet': '安装地毯',
    'InstallVinyl': '安装乙烯基',
    'InstallWallPaper': '安装墙纸',
    'InstallTile': '安装瓷砖',
    'InstallLaminate': '安装复合地板',
    'InstallHardwood': '安装实木地板',
    'Install Carpet': '安装地毯',
    'Install Vinyl': '安装乙烯基',
    'Install WallPaper': '安装墙纸',
    'Install Tile': '安装瓷砖',
    'Install Laminate': '安装复合地板',
    'Install Hardwood': '安装实木地板',
    'Price': '价格',
    'PleaseCheckOneLaborItemAtLast': '至少选择一个劳务项',
    'AreYouSureYouWantToDeleteTheseLaborItems': '您确定要删除这些劳务项吗？',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'Licenses': '许可证',
    'Total': '共{0}人, 剩余{1}人',
    'remaining': '剩余',
    'Storage': '存储容量',
    'Expired': '过期',
    'NextBilling': '下个账单日',
    'Upgrade': '升级版本',
    'Buy': '购买',
    'PaymentHistory': '支付历史',
    'SubscriptionID': '订阅ID',
    'Item': '项目',
    'Quantity': '数量',
    'Rate': '单价',
    'Subscription': '订阅 {type}, 待支付',
    'RenewedOn': '续订',
    'ProrationCharged': '按比例收费',
    'NextBillingDateIs': '下个账单日',
    'SubscriptionCreated': '订阅已创建, 等待付款',
    'SubscriptionResumed': '订阅已恢复, 等待付款',
    'SubscriptionPauseResumed': '订阅已恢复',
    'SubscriptionUpdated': '订阅更新',
    'SubscriptionCanceled': '订阅取消',
    'SubscriptionFailed': '付款失败',
    'SubscriptionPaused': '订阅暂停',
    'SubscriptionTryPay': '账单已创建，等待付款',
    'SubscriptionSent': '账单已发送，等待付款',
    'sSubscription': '的订阅',
    'Add': '新增',
    'Remove': '移除',
    'TurnOnAuto-Bill': '打开自动订阅',
    'TurnOffAuto-Bill': '关闭自动订阅',
    'Cancel': '取消',
    'Resume': '继续订阅',
    'Pause': '暂停',
    'LoadHistory': '查看历史',
    'CreatedOn': '创建于',
    'Amount': '合计',
    'Status': '状态',
    'Invoice#': '发票号',
    'Note': '说明',
    'TrakrStarter(Trial)': 'Trakr基础版(试用)',
    'EditPassword': '修改密码',
    'Activities': '动态',
    'NoData': '没有数据',
    'createdaTask': '创建任务 ({TaskName})',
    'assignTheTask': '将任务 ({0}) 分配给 {1}',
    'setTheProgress': '将任务（{0}）的进度设置为{1}%',
    'deletedaTask': '删除任务 ({0})',
    'addRHReadingToTask': '为任务({0})添加RH读数',
    'addCaClReadingToTask': '为任务({0})添加CaCl读数',
    'removeaRH': '从任务({0})中删除RH读数',
    'removeaCaCl': '从任务({0})中删除CaCl读数',
    'NewUser': '创建新用户',
    'LoginAccount': '登录账号',
    'LoginEmail': '邮箱',
    'ManageMySubscription': '管理订阅',
    'Role': '角色',
    'CreatedTime': '创建时间',
    'License': '许可证',
    'Delete': '删除',
    'AreYouSureYouWantToDeleteThisUser': '您确定要删除这个用户吗？',
    'LastActivity': '最新操作',
    'TotalProjectCount': '项目数',
    'TotalUserCount': '用户数',
    'TotalCompletedTaskCount': '已完成任务数',
    'TotalAssignToTaskCount': '分配给别人任务数',
    'TotalAssignedTaskCount': '被分配任务数',
    'More': '更多',
    'Created': '创建时间',
    'ResidualLicenseForNewUserTooltip': '您没有可用的license，要么购买更多用户，要么把不用用户disable掉。',
    'SearchUserName': '搜索用户名称',
    'SearchLoginAccount': '搜索账号'
  },
  'layout': {
    'Filter': '筛选',
    'Clearfilter': '清空选项',
    'ManageMySubscription': '管理订阅',
    'Upgrade': '升级版本',
    'Buy': '购买',
    'SearchOrJumpTo': '搜索或跳转',
    'AllReport': '全部报表',
    'Management': '管理',
    'MyCorp': '我的公司',
    'MyProfile': '个性化设置',
    'LogOut': '退出',
    'EndMock': '结束模拟',
    'MyTasks': '我的任务列表',
    'Reports': '报表'
  },
  'welcome': {
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'LogInToYourAccount': '登录您的账户',
    'NotRegistered': '没有注册？',
    'SignUp': '注册',
    'MeasureSquareID': 'Measure Square ID (邮箱)',
    'Password': '密码 *',
    'ForgotPassword': '忘记密码？',
    'Login': '登录',
    'MeasureSquareIDisRequired': '请输入Measure Square ID ',
    'PasswordIsRequired': '请输入密码',
    'CreateYourAccount': '创建您的账户',
    'AlreadyHaveAnAccount': '已有账户？',
    'SignIn': '登录',
    'Name': '姓名 *',
    'BusinessName': '公司名称 *',
    'YouNeedToEnteraValidemail': '请输入有效邮箱',
    'LoginAccount': '登录账户',
    'LoginAccountAlreadyExists': '登录账户已存在',
    'LoginAccountIsRequired': '请输入登录账户',
    'NameIsRequired': '请输入姓名',
    'PhonesRequired': '请输入电话号码',
    'BusinessNameIsRequired': '请输入公司名称',
    'ApplyNewPassword': '应用新密码',
    'NewPassword': '新密码',
    'ConfirmPassword': '确认密码 *',
    'AccountIsRequired': '请输入账户',
    'ConfirmPasswordDoseNotMatchPassword': '确认密码与密码不匹配',
    'ConfirmPasswordIsRequired': '请输入确认密码',
    'WelcomeToJoin': '欢迎加入',
    'YouNeedToEnteraValidEmail': '请输入有效邮箱',
    'ResetPassword': '重置密码',
    'Email': '邮箱',
    'SendEmail': '发送邮件',
    'EmailSent': '邮件已发送！',
    'WeJustSentAnEmailTo': '我们刚刚发送了邮件给',
    'check': '如果现在去检查您的电子邮件，会发现一条来自我们的消息，说明如何为您的帐户设置新密码。',
    'notreceive': '如果您在几分钟内未收到我们的电子邮件，请检查您的邮件垃圾箱。',
    'BackTo': '返回',
    'EmailIsRequired': '请输入邮箱',
    'Projects': '项目',
    'Open': '活跃',
    'Closed': '已关闭',
    'NewProject': '创建项目',
    'Filters': '筛选',
    'Loading': '加载中',
    'Phone': '电话 *',
    'CorpNameAlreadyExists': '公司名称已存在'
  },
  'home': {
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'Welcome': '欢迎',
    'happening': '这是在您的项目中{0}更新的信息',
    'EditProject': '编辑项目',
    'CloseProject': '关闭项目',
    'Progress': '进度',
    'CreateBy': '{1}由 {0} 创建',
    'PLANS': '平面图',
    'AddPlan': '导入平面图',
    'TASKS': '任务',
    'Open': '活跃',
    'All': '全部',
    'REPORTS': '报表',
    'Activities': '最近20条动态',
    'NoData': '没有数据',
    'AreYouSureYouWantToCloseThisProject': '您确定要关闭当前项目?',
    'createdaTask': '创建任务 ({0})',
    'assignTheTask': '将任务 ({0}) 分配给 {1}',
    'setTheProgress': '将任务（{0}）的进度设置为{1}%',
    'deletedaTask': '删除任务 ({0})',
    'addRHReadingToTask': '为任务({0})添加RH读数',
    'addCaClReadingToTask': '为任务({0})添加CaCl读数',
    'removeaRH': '从任务({0})中删除RH读数',
    'removeaCaCl': '从任务({0})中删除CaCl读数',
    'createdaPlan': '创建平面图 ({0})',
    'deletedaPlan': '删除平面图 ({0})',
    'ReopenProject': '重新打开项目',
    'AreYouSureYouWantToReopenThisProject': '您确定要重新打开当前项目?',
    'loggedInSystem': '登录'
  },
  'diagrams': {
    'AddPlans': '导入平面图',
    'EditPlan': '编辑图纸信息',
    'Name': '名称',
    'Rename': '重命名',
    'Delete': '删除',
    'Today': '今天',
    'Open': '活跃',
    'NoData': '没有数据',
    'Warning': '警告',
    'cannotBeDeleted': '该图纸已添加任务，无法删除！',
    'wantToDelete': '您确定要删除 {0}？',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'AddPlanFromPDF': '从PDF导入平面图',
    'SearchPlanName': '搜索平面图名称',
    'SearchTag': '搜索标签'
  },
  'documents': {
    'Add': '添加',
    'Folder': '文件夹',
    'Document': '文件',
    'NewFolder': '新增文件夹',
    'RenameFolder': '重命名文件夹',
    'Cancel': '取消',
    'Save': '保存',
    'UploadDocument': '上传文件',
    'PleaseSelectDocument': '请选择文档',
    'AreYouSureYouWantToDeleteDocuments': '您确定要删除选中的文档？',
    'Name': '名称',
    'SearchDocumentName': '搜索文件名称'
  },
  'group': {
    'NewTaskGroup': '创建任务组',
    'Name': '名称',
    'Edit': '编辑',
    'Tasks': '任务',
    'Delete': '删除',
    'DueOn': '截止日期',
    'Open': '已开始({0})',
    'Complete': '已完成 ({0})',
    'NoData': '没有数据',
    'AreYouSureYouWantToDeleteThisGroup': '您确定要删除这个任务组？',
    'Yes': '是',
    'No': '否',
    'Progress': '进度',
    'Concrete': '混凝土',
    'TIPS': '提示',
    'SearchTaskGroupName': '搜索任务组名称'
  },
  'members': {
    'AddMembers': '添加项目成员',
    'Name': '名称',
    'Email': '邮箱',
    'Role': '角色',
    'AreYouSureYouWantToDeleteThisMember': '您确定要删除这个项目成员？',
    'Yes': '是',
    'No': '否',
    'TIPS': '提示',
    'SearchMemberName': '搜索成员名称'
  },
  'photo': {
    'Upload': '上传图片或视频',
    'Task': '任务',
    'LastUpdatedOn': '更新时间',
    'Delete': '删除',
    'Download': '下载',
    'NoData': '没有数据',
    'AreYouSureYouWantToDeleteThesePhotos': '您确定要删除选中的照片？',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'PleaseSelectPhoto': '请选择照片',
    'Plan': '平面图',
    'RoomName': '房间名称',
    'TaskName': '任务名称',
    'NotFound': '找不到照片.',
    'SearchPlan': '搜索平面图',
    'SearchTaskName': '搜索任务名称',
    'SearchRoom': '搜索房间'
  },
  'report': {
    'Name': '名称',
    'Type': '类型',
    'BatchDelete': '批量删除',
    'ProjectName': '项目名称',
    'CreatedTime': '创建时间',
    'Actions': '操作',
    'Delete': '删除',
    'AreYouSureYouWantToDeleteThisReport': '您确定要删除这个报表？',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'PleaseCheckOneTaskAtLast': '请至少勾选一个任务',
    'AreYouSureYouWantToDeleteTheseReport': '您确定要删除选中的报表？',
    'Report': '报表',
    'Task': '任务',
    'ProductInstallation': '材料安装',
    'Moisture': '湿度',
    'Task Report': '任务',
    'Moisture Report': '湿度',
    'Labor Report': '劳务',
    'Plan': '平面图',
    'All': '全部',
    'SearchReportName': '搜索报表名称',
    'Download': '下载',
    'SendEmail': '发送邮件'
  },
  'task': {
    'AddTask': '创建任务',
    'CompletionRate': '完成度',
    'All': '全部',
    'Filters': '筛选',
    'Name': '名称',
    'Status': '状态',
    'DueDate': '截止日期',
    'Watching': '相关人员',
    'BatchDelete': '删除',
    'BatchEdit': '编辑',
    'ExportToFile': '导出(所有)',
    'Plan': '平面图',
    'Project': '项目',
    'Group': '任务组',
    'SearchTaskName': '搜索任务名称',
    'NoTasksFound': '找不到所选类型\'{0}\'的任务',
    'NoTasksFoundByCondition': '找不到匹配的任务.',
    'PleaseCheckOneTaskAtLast': '请至少勾选一个任务',
    'AreYouSureYouWantToDeleteTheseTasks': '您确定要删除这些任务？',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'TaskGroup': '任务组',
    'LocationType': '位置类型',
    'Floor': '地板',
    'Wall': '墙',
    'Elevation': '凸起物',
    'Assignee': '执行人',
    'Report': '报表',
    'Task': '任务',
    'ProductInstallation': '材料安装',
    'Product Installation': '材料安装',
    'Moisture': '湿度',
    'NewReport': '创建报表',
    'Concrete': '混凝土',
    'Labor': '劳务',
    'Start': '开始',
    'End': '结束',
    'CreatedOn': '创建时间',
    'UpdatedOn': '更新时间'
  },
  'static': {
    'Labor': '劳务报表',
    'Metric': '米制',
    'Imperial': '英制',
    'Celsius': '摄氏度',
    'Fahrenheit': '华氏度',
    'Overview': '总览',
    'plan': '平面图',
    'Tasks': '任务',
    'TaskGroups': '任务组',
    'Reports': '报表',
    'Liveanalytics': '分析',
    'Photos': '照片',
    'Documents': '文件',
    'Members': '项目成员',
    'MyCorp': '我的公司',
    'UserManagement': '用户管理',
    'Subscription': '订阅',
    'Corporations': '公司',
    'AllUsers': '全部用户',
    'LaborItems': '劳务项',
    'Settings': '设置',
    'SysSetting': '系统设置',
    'days': ' 天',
    'day': ' 天',
    'YourTrialIsExpired': '您的试用已过期!',
    'FreeLicenses': ' 免费许可证, ',
    'licensesPurchased': ' 个许可证已购买, ',
    'assigned': ' 个已分配',
    'YourSubscriptionIsExpired': '您的订阅已过期!',
    'YourSubscriptionWillExpired': '您的订阅{0}将会在{1}天后到期。',
    'justThen': '刚刚',
    'secondsAgo': ' 秒前',
    'aMinuteAgo': ' 一分钟前',
    'minutesAgo': ' 分钟前',
    '1hourAgo': ' 一小时前',
    'hoursAgo': ' 小时前',
    'yesterday': '昨天',
    'daysAgo': ' 天前',
    'aWeekAgo': '一周前',
    'weeksAgo': ' 周前',
    'LicenseDisabledTitle': '您的账号已被禁用',
    'LicenseExpiredTitle': '订阅已过期',
    'LicenseDisabledNote': '您的账号{0}已被禁用, 请联系管理员',
    'LicenseExpiredNote': '您的订阅{0}已过期',
    'Products': '材料',
    'Tags': '标签',
    'TaskGroupTemplates': '任务组模板'
  },
  'router': {
    'Login': '登录',
    'Register': '注册',
    'Invite': '邀请',
    'Forgot': '忘记密码',
    'ResetPassword': '重置密码',
    'LoginToLicense': '登录许可证',
    'Projects': '项目',
    'Home': '总览',
    'Tasks': '任务',
    'Plans': '平面图',
    'TaskGroups': '任务组',
    'Reports': '报表',
    'Liveanalytics': '分析',
    'Photos': '照片',
    'Documents': '文件',
    'Members': '项目成员',
    'Corp': '公司',
    'UserManagement': '用户管理',
    'Subscription': '订阅',
    'MyProfile': '个性化设置',
    'Corporations': '公司',
    'AllUsers': '全部用户',
    'LaborItems': '劳务设置',
    'CorpSetting': '公司设置',
    'SysSetting': '系统设置',
    'TaskList': '任务列表',
    'ByRoom': '按房间',
    'room': '房间',
    'ByProduct': '按材料',
    'Task': '任务',
    'batchTask': '批量任务',
    'role': '角色',
    'Tags': '标签',
    'taskGroupTemplates': '任务组模板'
  },
  'model': {
    'tasks are going to be created': '个任务会被出创建',
    'Probe': '探测',
    'showImage': '显示底图',
    'Product': '材料',
    'task': '任务',
    'ZoomIn': '放大',
    'ZoomOut': '缩小',
    'ZoomAll': '重置',
    'Task': '任务',
    'Tasks': '任务',
    'ProductInstallation': '材料安装',
    'TaskTemplate': '模板任务',
    'Moisture': '湿度',
    'ClearFilter': '清空选项',
    'Type': '类型',
    'Status': '状态',
    'TaskGroup': '任务组',
    'LocationType': '位置类型',
    'DueDate': '截止日期',
    'From': '从',
    'To': '到',
    'Assignee': '执行人',
    'Watching': '相关人员',
    'AddTask': '创建任务',
    'Rooms': '房间',
    'Products': '材料',
    'ThereIsNoProduct': '这里没有材料',
    'PleaseCreate': '请首先创建一个{0}任务。',
    'Wall': '墙面',
    'Label': '标签',
    'Dimension': '尺寸',
    'WallSection': '墙段',
    'Annotation': '备注',
    'RoomName': '房间名称',
    'Name': '名称',
    'StartDate': '开始日期',
    'Location': '位置',
    'Description': '描述',
    'Cancel': '取消',
    'Save': '保存',
    'Next': '下一步',
    'SelectRoom': '选择房间',
    'MaxRH': 'MaxRH',
    'HoleDepth': '孔深',
    'CreateTaskForEveryRoom': '为每个房间创建任务',
    'EditTasks': '编辑任务',
    '%Done': '完成百分比',
    'Delete': '删除',
    'AreYouSureYouWantToDeleteTheseTasks': '您确定要删除这些任务？',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'Search': '搜索',
    'CreateTask': '创建任务',
    'ChangeAll': '全部修改',
    'NetArea': '净面积',
    'Installed': '已安装',
    'MarkAsDone': '标记为已完成',
    'Floor': '地板',
    'Base/LF': '基线/线性材料',
    'Door': '门',
    'Successfully': '保存成功',
    'AddReading': '添加读数',
    'Category': '类别',
    'TotalQty': '总量',
    'QtyInstalled': '已安装总量',
    'RHInConcrete': '混凝土中的RH',
    'PHTesting': 'PH测试',
    'StartingWeight': '起始重量',
    'EndingWeight': '结束重量',
    'NetWeightGain': '净增重',
    'ConCrete': '混凝土',
    'Ambient': '环境',
    'SurfaceTemp': '表面温度',
    'MoreReading': '更多读数信息',
    'AddPhoto': '添加照片',
    'AreYouSureYouWantToDeleteThisPhoto': '您确定要删除这张照片？',
    'AreYouSureYouWantToDeleteThisTask': '您确定要删除这个任务？',
    'BatchEdit': '批量编辑任务',
    'Labor': '劳务',
    'Select': '请选择',
    'SelectAssignee': '谁需要做这个?',
    'SelectWatching': '谁应该知道这些?',
    'DescribeTheTask': '说明这个任务',
    'SearchTaskName': '搜索任务名称',
    'TaskTotalQty': '任务总量',
    'JobsiteTotalQty': '项目总量',
    'RetainageQty': '余量',
    'TaskTotalQtyCannotGreaterThanJobsiteRetaingeQty': '任务总量不能超出项目余量',
    'PleaseSelectOneProduct': '请选择材料',
    'PleaseSelectOneTemplate': '请选择模板',
    'DragToAdd': '拖动并在图上单击',
    'Addmultipletasksfromrooms': '从房间创建任务',
    'Addmultipletasksfromproducts': '从材料创建任务'
  },
  'upload': {
    'SelectFile': '选择文件',
    'SelectPhoto/Video': '选择照片或视频',
    'SelectPhoto': '选择照片',
    'Upload': '上传',
    'Uploading': '上传中',
    'Waiting': '处理文件中，请稍等',
    'Cancel': '取消',
    'SelectDoc': '选择文件'
  },
  'taskDialog': {
    'Are you sure you want to delete this file?': '您确定要删除这个文件？',
    'Task': '任务',
    'AddMoisture': '添加读数',
    'Saving': '保存中...',
    'Location': '位置',
    'Description': '描述',
    'AddReading': '添加读数',
    'Name': '名称',
    'Category': '类别',
    'Status': '状态',
    '%Done': '完成百分比',
    'TaskGroup': '任务组',
    'StartDate': '开始日期',
    'DueDate': '截止日期',
    'Assignee': '执行人',
    'Watching': '相关人员',
    'Product': '材料',
    'NetArea': '净面积',
    'TotalQty': '总数量',
    'QtyInstalled': '已安装总量',
    'Installed': '已安装',
    'ChangeAll': '全部修改',
    'MaxRH': 'MaxRH',
    'RHInConcrete': '混凝土中的RH',
    'PHTesting': 'PH测试',
    'HoleDepth': '孔深',
    'StartingWeight': '起始重量',
    'EndingWeight': '结束重量',
    'NetWeightGain': '净增重',
    'ConCrete': '混凝土',
    'Ambient': '环境',
    'SurfaceTemp': '表面温度',
    'MoreReading': '更多读数信息',
    'AddPhoto': '添加照片',
    'Delete': '删除',
    'Save': '保存',
    'MarkAsDone': '标记为已完成',
    'AreYouSureYouWantToDeleteThisChecklist': '您确定要删除这个检查清单？',
    'AreYouSureYouWantToDeleteThisChecklistItem': '您确定要删除这个检查项？',
    'AreYouSureYouWantToDeleteThisPhoto': '您确定要删除这张照片？',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'AreYouSureYouWantToDeleteThisTask': '您确定要删除这个任务？',
    'Floor': '地板',
    'Base/LF': '基线/线性材料',
    'Door': '门',
    'Wall': '墙面',
    'ReadingList': '读数列表',
    'AreYouSureYouWantToDeleteThisReading': '您确定要删除这个读数？',
    'EditTasks': '编辑任务',
    'RH': 'RH',
    'CaCl': 'CaCl',
    'ConcreteTemp': '混凝土温度',
    'AmbientTemp': '环境温度',
    'ConcreteSurfaceTemp': '混凝土表面温度',
    'AmbientRH': '环境RH',
    'ReadingTime': '读数时间',
    'CaClStartingWeight': 'CaCl起始重量',
    'CaClEndingWeight': 'CaCl结束重量',
    'ExposureTime': '曝光时间',
    'RequireNumber': '请输入数字',
    'PHTestingIsError': 'PH测试有误',
    'PHTestingIsEmpty': '请输入PH测试',
    'CaClStartingWeightIsError': 'CaCl起始重量有误',
    'CaClStartingWeightIsEmpty': '请输入CaCl起始重量',
    'CaClEndingWeightIsError': 'CaCl结束重量有误',
    'CaClEndingWeightNeedBiggerThanCaClStartingWeight': 'CaCl结束重量须大于起始重量',
    'CaClEndingWeightIsEmpty': '请输入CaCl结束重量',
    'CaClStartingTimeIsEmpty': '请输入CaCl开始时间',
    'CaClEndingTimeNeedLaterThanCaClStartingTime': 'CaCl结束时间须大于开始时间',
    'CaClEndingTimeIsEmpty': '请输入CaCl结束时间',
    'RHReadingMustHaveArecordValue': '请输入RH读数',
    'EndTime': '结束时间',
    'StartTime': '开始时间',
    'Cancel': '取消',
    'Video': '视频',
    'FromLocalDisk': '本地磁盘',
    'FromProjectDocuments': '项目文档',
    'AddFile': '添加文件',
    'Checklists': '检查清单',
    'AddChecklist': '添加检查清单',
    'RepeatAssignFileToTask': '该文件已添加到当前任务，请不要再次添加',
    'VaporEmission': 'MVER',
    'TaskTotalQty': '任务总量',
    'JobsiteTotalQty': '项目总量',
    'RetainageQty': '余量',
    'TaskTotalQtyCannotGreaterThanJobsiteRetaingeQty': '任务总量不能超出项目余量',
    'PleaseSelectOneProduct': '请选择材料'
  },
  'project': {
    'Upload': '上传文件',
    'NoData': '无数据',
    'Skip': '跳过',
    'SelectPlan': '选择平面图',
    'SelectLayers': '选择图层',
    'CreateProject': '创建项目',
    'CreateWithCloud': '选择一个MeasureSqaure Cloud项目',
    'CreateWithPdf': '选择一个PDF图纸',
    'CreateWithPdfs': '选择PDF图纸',
    'CreateWithEmpty': '稍后添加图纸',
    'EnterInformation': '输入项目信息',
    'SearchforPlans': '搜索平面图',
    'Name': '名称',
    'Owner': '所有者',
    'LastUpdated': '更新',
    'SelectAll': '全选',
    'Selected': '选中',
    'NoneSelected': '未选择图纸',
    'ProjectManager': '项目经理',
    'InstallationManager': '安装经理',
    'Subcontract': '分包商',
    'Street': '街道',
    'City': '市',
    'State': '省',
    'ZipCode': '邮政编码',
    'Country': '国家',
    'Cancel': '取消',
    'Previous': '上一步',
    'Next': '下一步',
    'Save': '保存',
    'OK': '保存',
    'PleaseEnterAname': '请输入名称',
    'EditProject': '编辑项目',
    'Address': '地址',
    'Members': '项目成员',
    'SelectMembers': '选择项目成员'
  },
  'PhotoDialog': {
    'notsupported': '不支持H.265/HEVC文件'
  },
  'member': {
    'AddMembers': '添加项目成员',
    'SearchforMembers': '搜索项目成员',
    'Add': '添加',
    'Cancel': '取消',
    'NewCorpUser': '添加用户'
  },
  'management': {
    'ApplyToCorps': '应用于公司',
    'Corporations': '公司',
    'CompanyName': '公司名称',
    'Contact': '联系人',
    'Id': 'Id',
    'CreatedTime': '创建时间',
    'Apply': '应用',
    'Cancel': '取消',
    'PleaseCheckOneCorporationAtLast': '请至少勾选一个公司',
    'ObjectTypeName': '对象类型名称',
    'Items': '项',
    'Remark': '备注',
    'Add': '添加',
    'Delete': '删除',
    'Save': '保存',
    'ObjectTypeNameIsRequired': '请输入对象类型名称',
    'Edit': '编辑',
    'New': '创建',
    'AreYouSureYouWantToDeleteThisCorp': '您确定要删除这个公司?',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'ExportToCSV': '导出CSV',
    'ExportToExcel': '导出Excel'
  },
  'groupDialog': {
    'Name': '名称',
    'StartDate': '开始日期',
    'DueDate': '截止日期',
    'Description': '描述',
    'Save': '保存',
    'Cancel': '取消',
    'AddTaskGroup': '新建任务组',
    'PleaseEnterAName': '请输入名称',
    'EditTaskGroup': '编辑任务组',
    'PhaseType': '类型',
    'General': '普通',
    'BillingPeriod': '结算期',
    'IsCurrent': '当前结算',
    'PleaseEnterAStartDate': '请输入开始日期',
    'PleaseEnterADueDate': '请输入截止日期',
    'StartDateCannotGreaterThenDueDate': '开始日期不能大于截止日期',
    'DueDateCannotGreaterToday': '截止日期不能大于今天',
    'DescribeTheTaskGroup': '说明这个任务组',
    'EditTaskGroupTemplate': '编辑任务组模板',
    'AddTaskGroupTemplate': '新增任务组模板'
  },
  'diagramDialog': {
    'SelectPlan': '选择平面图',
    'SelectLayers': '选择图层',
    'SearchforPlans': '搜索平面图',
    'Name': '名称',
    'Owner': '所有者',
    'LastUpdated': '更新',
    'SelectAll': '全选',
    'Cancel': '取消',
    'Previous': '上一步',
    'Save': '保存',
    'AddingPlan': '导入平面图',
    'AddPlanFromPDF': '从PDF导入平面图',
    'SelectPDF': '选择PDF',
    'SelectPages': '选择页',
    'PagesSelected': '已选中{0}页',
    'SearchPage': '搜索选择页',
    'PdfError': '无效的PDF',
    'SaveFailed': '保存失败',
    'PdfTooLarge': 'Pdf文件太大'
  },
  'corpDialog': {
    'Previous': '上一步',
    'Next': '下一步',
    'SubscribetoJobsiteTrakr': '订阅 Job Trakr',
    'month': '月',
    'MONTHLY': '月',
    'year': '年',
    'YEARLY': '年',
    'license': '许可证',
    'Starter': 'Starter',
    'Pro': 'Pro',
    'Enterprise': 'Enterprise',
    'ProInfo1': 'Unlimited Projects (5 Licenses, 200 GB Storage)',
    'ProInfo2': 'Collaboration Among Team, Subs And Clients',
    'ProInfo3': 'Moisture Reporting, Bluetooth Meter Integration',
    'ProInfo4': 'Additional License',
    'People': '人',
    'More': '更多',
    'Total': '总共',
    'Cancel': '取消',
    'Buy': '购买',
    'Pleasecreateyourcompanyinformationfirst': '请先创建公司信息',
    'Company': '公司',
    'BusinessName': '公司名称',
    'Address': '地址',
    'City': '城市',
    'State': '省',
    'ZipCode': '邮政编码',
    'Country': '国家',
    'ContactInfo': '联系方式',
    'Contact': '联系人',
    'Phone': '电话',
    'Fax': '传真',
    'Email': '邮箱',
    'Save': '保存',
    'BusinessNameisrequired': '请输入公司名称',
    'Logo': '标志',
    'Add': '添加',
    'Up': '向上',
    'Down': '向下',
    'Delete': '删除',
    'Close': '关闭',
    'NoType': '没有类型',
    'Typenotempty': '类型不能为空',
    'TypeIsrequired': '请选择类型',
    'Edit': '编辑',
    'CorpSetting': '公司设置',
    'M2Integration': '集成M2',
    'Unit': '单位',
    'TemperatureUnit': '温度单位',
    'Name': '名称',
    'InstallCarpet': '安装地毯',
    'InstallVinyl': '安装乙烯基',
    'InstallWallPaper': '安装墙纸',
    'InstallTile': '安装瓷砖',
    'InstallLaminate': '安装复合地板',
    'InstallHardwood': '安装实木地板',
    'Price': '价格',
    'AddLaborItem': '添加劳务项',
    'Nameisrequired': '请输入姓名',
    'EditLaborItem': '编辑劳务项',
    'Hardwood': '实木地板',
    'Laminate': '复合地板',
    'Tile': '瓷砖',
    'WallPaper': '墙纸',
    'VinylRoll,VinylTile': '乙烯基卷,乙烯基块',
    'CarpetRoll,CarpetTile': '地毯卷,地毯块',
    'ChangePassword': '修改密码',
    'Password': '密码',
    'OldPassword': '旧密码',
    'NewPassword': '新密码',
    'ConfirmPassword': '确认密码',
    'Passwordisrequired': '请输入密码',
    'Confirmpassworddosenotmatchpassword': '确认密码与密码不匹配',
    'ConfirmPasswordisrequired': '请输入确认密码',
    'EditTrialExpiration': '编辑试用期',
    'TrialExpiration': '试用期',
    'Type of service life': '正式类型',
    'duration': '时长',
    'number': '数量',
    'AccountInfo': '账户信息',
    'LoginAccount': '登录账户',
    'UserInfo': '用户信息',
    'FullName': '姓名',
    'Role': '角色',
    'CompanyName': '公司名称',
    'CorpIsrequired': '请选择公司',
    'EditUser': '编辑用户',
    'SubscriptionDetail': '订阅详情',
    'CreatedOn': '创建于',
    'Rate': '费用',
    'Quantity': '数量',
    'Nextbillingdate': '下个账单日',
    'Action': '操作',
    'AddUser': '添加用户',
    'Selectonerole': '请选择一个角色',
    'LoginAccountisrequired': '请输入登录账户',
    'Youneedtoenteravalidemail': '请输入有效邮箱',
    'Avatar': '头像',
    'EditLicense': '编辑许可证',
    'TrialExpirationDate': '试用期时间'
  },
  'reportDialog': {
    'Loading': '保存中',
    'Type': '类型',
    'SendMail': '发送邮件',
    'To': '收件人',
    'Subject': '标题',
    'Content': '内容',
    'Report': '报表',
    'Cancel': '取消',
    'Send': '发送',
    'Toisrequired': '请输入收件人',
    'Youneedtoenteravalidemail': '请输入有效邮箱',
    'Subjectisrequired': '请输入标题',
    'Name': '名称',
    'Orientation': '方向',
    'Landscape': '横向',
    'Portrait': '纵向',
    'RH': 'RH',
    'Cacl': 'CaCl',
    'RH&Cacl': 'RH & CaCl',
    'ShowProduct': '显示材料',
    'ShowTaskList': '显示任务列表',
    'ShowFloorPlan': '显示平面图',
    'ShowPhotos': '显示照片',
    'Previous': '上一步',
    'Next': '下一步',
    'Save': '保存',
    'Nameisrequired': '请输入名称',
    'ProductInstallation': '材料安装',
    'Moisture': '湿度',
    'Task': '任务',
    'Report-': ' 报告 - ',
    'Progress': '进度',
    'Concrete': '混凝土',
    'Plan': '平面图',
    'Location': '位置',
    'Done': '完成度',
    'DueDate': '截止日期',
    'StartDate': '开始日期',
    'Assignee': '执行人',
    'Status': '状态',
    'Notes': '说明',
    '%Done': '完成百分比',
    'Area': '区域',
    'Group': '任务组',
    'CreateBy': '创建人',
    'Job': '项目',
    'MeasrueSquareCorp': 'Measrue Square Corp.',
    '221EWalnutSt': '221 E Walnut St, Suite 110, Pasadena, CA 91101 support@measuresquare.com',
    'Jobinfo': '项目信息',
    'Photos': '照片',
    'Date': '日期',
    'AmbientRH%': '环境RH, %',
    'AirTemp': '空气温度',
    'ConcreteSurfaceTemp': '混凝土表面温度',
    'ConcreteTemp': '混凝土温度',
    'RHInConcrete%': '混凝土RH, %',
    'Reading': '读数',
    'MaxRH%': '最大RH, %',
    'MAX72Hrs': '最长72小时',
    'Min60Hrs': '最短60小时',
    'TestTime': '测试时间',
    'LBS': 'LBS. per 1000 sq/ft in a 24 hour period.',
    'Hrs': 'Hrs. Exposed = (Total)',
    'Gain': 'Gain in Weight(Grams) ✖ 117.707 = (Divided by Total Below) =',
    'MOISTUREFORMULA': 'MOISTURE FORMULA',
    'Thenmop': 'Then mop with Tap water. Repeat the procedure twice, then test again. Typically the higher the PH.',
    'Floors': 'Floors with a PH Level of 9 or higher must be corrected. It may be reduced by mopping the floor with a 10% Muriatic Acid wash. Allow the acid wash to dry. ',
    'ALLOWEDIS-8': 'ALLOWED IS - 8',
    'MAXIMLIMPH': 'MAXIMLIM P H',
    'lbs': 'lbs. or Less Over 1000 s/f in 24 hrs.',
    'MAXIMLIM': 'MAXIMLIM',
    'RECOMMENDED': 'RECOMMENDED',
    'MOISTURELEVELS': 'MOISTURE LEVELS',
    'BYTHE': 'BY THE C.R.I. &',
    'RFCIS': 'R.F.C.I.S',
    'Rubber': "Rubber Tile / Solid Vinyl Tile / Wood / PVC Vinyl / Vinyl Strip / PVC Vinyl Backed Carpets / Epoxy's",
    'Felt': 'Felt Backed Sheet Vinyl / Action Back Carpet / Linoleum (Varies by Manufacturer 3# to 5#).',
    'Vinyl': 'Vinyl Composition Tile. (Varies by Manufacture 5# to 7#).',
    'Depth': '板材测孔深度',
    'RHinConcrete': '混凝土RH, %',
    'PHTesting': 'PH测试',
    'AmbientRH': '环境RH, %',
    'WeightGaining': '净增重g.',
    'ExposureTime/Hrs': '曝光时间/小时',
    'Quatitive': '无水CaCl测试(板材的湿度蒸汽读数)',
    'Static': '静态湿度状况(板材中的湿度)',
    'AlkalinityCondition': '碱度条件',
    'LocationRm': '房间位置',
    'MaxRH': '最大 RH, %',
    'RHInConcrete': '混凝土RH , %',
    'CaClStartingWeight': 'CaCl起始重量',
    'CaClEndingWeight': 'CaCl结束重量',
    'NetGramGainOf': '净增重',
    'StartTime': '开始时间',
    'EndTime': '结束时间',
    'TotalTime': '总时长(时:分)',
    'TestHas': '测试已通过/失败',
    'HoleDepth': '孔深',
    'Temp&Humidity': '温度和湿度条件在测试期间和之前稳定48小时',
    'A/CSystem': '空调系统至少运行48小时；',
    'TIP': '提示: - 表示未测',
    'TotalCheck': '检查 > RH 读数;',
    'Product': '材料',
    'TotalQty': '总量',
    'Installed': '已安装',
    'InstalledQty': '安装总量',
    'Plans': '平面图',
    'ProjectName': '项目名称',
    'ProjectNumber': '项目 #',
    'ProjectManagerName': '项目经理',
    'InstallationManagerName': '安装经理',
    'SubcontractorName': '分包商',
    'LaborDateRange': '劳务日期范围',
    'SummaryInformation': '摘要信息',
    'LaborDetails': '劳务详情',
    'Quantity': '数量',
    'LaborDescription': '劳务描述',
    'Price': '价格',
    'LineTotal': '行汇总',
    'Room': '房间',
    'CompletionDate': '完成日期',
    'ReportTotal': '报表汇总',
    'PunchRetainage': '留用金',
    'SubcontractorPayroll': '分包商薪金',
    'SubcontractorLaborReport': '分包商劳务报表',
    'UOM': 'UOM',
    'CarpetRoll': '地毯卷',
    'VinylRoll': '乙烯基卷',
    'WallPaper': '墙纸',
    'CarpetTile': '地毯块',
    'VinylTile': '乙烯基块',
    'Tile': '瓷砖',
    'Laminate': '复合板',
    'Hardwood': '硬木板',
    'Paint': '油漆',
    'Grout': '填缝剂',
    'AreaSurface': '面积材料',
    'AreaUnderlay': '衬底',
    'Transition': '过渡条',
    'Bullnose': '牛鼻边',
    'Trim': '贴边',
    'WallBase': '踢脚线',
    'LinearRegular': '线性材料',
    'Count': '计数材料',
    'AreaAdhesive': '粘合剂',
    'Labor': '人工费',
    'Freight': '运费',
    'Carpet': '地毯',
    'Install': '安装',
    'SetEndTimeNote': '结束时间必须大于开始时间。',
    'None': '无',
    'MissingLaborItem': '有一些未设置的相关项目。'
  },
  'api': {
    'WARNING': '警告',
    'ERROR': '错误',
    'Successfully': '成功',
    'This': '该项目未加载',
    'Job Trakr Starter': 'Job Trakr 基础版',
    'Job Trakr Pro': 'Job Trakr 专业版',
    'Job Trakr Enterprise': 'Job Trakr 企业版',
    'Pause': '暂停',
    'Paid': '已支付',
    'Resume': '继续订阅',
    'Updated': '更新',
    'Canceled': '已取消',
    'Created': '创建',
    'Recurring Billing': '重复计费',
    'Proration Charge': '比例收费',
    'Sent': '已发送',
    'Month': '月',
    'Turn off the auto-bill for the subscription': '关闭订阅自动续费',
    'Find a better software/services.': '发现更好的软件/服务',
    'Overdue invoice. Subscription canceled automatically.': '过期发票。订阅已自动取消。',
    'Job Trakr Monthly Subscription': 'Job Trakr月订阅',
    'Job Trakr YEARLY Subscription': 'Job Trakr年订阅',
    'Job Trakr Starter Monthly Subscription': 'Job Trakr 基础版按月订阅',
    'Job Trakr Starter Annual Subscription': 'Job Trakr 基础版按年订阅',
    'Job Trakr Pro Monthly Subscription': 'Job Trakr 专业版按月订阅',
    'Job Trakr Pro Annual Subscription': 'Job Trakr 专业版按年订阅',
    'Job Trakr Enterprise Monthly Subscription': 'Job Trakr 企业版按月订阅',
    'Job Trakr Enterprise Annual Subscription': 'Job Trakr 企业版按年订阅',
    'Invalid members': '无效成员',
    'AccountExist': '账户名已存在',
    'Project Manager': '项目经理',
    'Administrator': '管理员',
    'Superintendent': '负责人',
    'Field Rep': '现场代表',
    'Project Status': '项目状态',
    'Task Status': '任务状态',
    'Task Tags': '任务标签',
    'Task Work Type': '任务工作类型',
    'Task Progress Options': '任务进度选项',
    'me': '我',
    '400': '帐户或密码无效',
    '403': '您的帐户没有许可证, 请联系您的JobTrakr管理员分配或购买一个.',
    '405': '您的订阅已过期.',
    'TIPS': '提示',
    'This project can not check on web': '该项目无法在web中查看',
    'The Name field is required': '请输入任务名称',
    'Year': '年',
    'Ultimate': '无上限',
    'Due Date need to later than Start Date': '截止日期需要晚于开始日期',
    'Open': '未开始',
    'Pending': '等待',
    'Completed': '已完成',
    'In Progress': '进行中',
    'Planned Work': '计划',
    'Issues': '问题',
    'Issue': '问题',
    'Fileslargerthan50Mcannotbeuploaded': '不能上传超过50M的文件',
    'PhotoOrVideolargerthan50Mcannotbeuploaded': '不能上传超过50M的图片或视频'
    // '4001': '不能超过购买的最大用户数。'
  },
  role: {
    'Create Project': '创建项目',
    'Edit Project': '编辑项目',
    'Close Project': '关闭项目',
    'Add Plan': '添加平面图',
    'Delete Plan': '删除平面图',
    'Add Task': '新增任务',
    'Edit Task': '编辑任务',
    'Assign Task': '分配任务',
    'Delete Task': '删除任务',
    'Create Report': '创建报表',
    'Edit Task Group': '编辑任务组',
    'Create Task Group': '创建任务组',
    'Delete Task Group': '删除任务组',
    'My Corp': '我的公司',
    'Edit Member': '编辑成员',
    'just the task assignd': '仅被分配的任务',
    'Permission': '权限',
    'Administrator': '超级管理员',
    'Project Manager': '项目经理',
    'Superintendent': '负责人',
    'Field Rep': '现场代表'
  },
  'store': {
    'Loading': '加载中'
  },
  'labor': {
    'Add Labor Group': '添加劳务报表',
    'Name': '名称',
    'Trades': '类别',
    'Retainage Rate:': '保留比例',
    'Labor': '劳务报表',
    'Job Name:': '工程名称',
    'Trades:': '类别',
    'Time Ranges:': '时间区间',
    'All': '全部',
    'Edit': '编辑',
    'Edit Labor Report': '编辑劳务报表',
    'Delete Labor Report': '删除劳务报表',
    'Description of Work': '工作描述',
    'Previous Billings': '前期账单',
    'Current Billing': '当前账单',
    'Total Completed': '全部完成',
    'Uncompleted': '未完成',
    'Retainage': '比例',
    'Action': '操作',
    'Previous Billings:': '前期账单: ',
    'Current Billing:': '当前账单:',
    'Total Completed:': '全部完成:',
    'Sub Totals:': '小计:',
    'Retainage:': '比例:',
    'Uncompleted:': '未完成:',
    'Amount': '合计',
    'Unit Cost': '单位价格',
    'Cancel': '取消',
    'Save': '保存',
    'Are you sure you want to delete this labor group?': '确定删除这个劳务报表?',
    'TIPS': '提示',
    'Please Enter A Name': '请输入名称',
    'Please Enter Retainage Rate from 0 to 100': '保留比例在0到100之间',
    'Please Enter Retainage Rate': '请输入保留比例',
    'Please Enter Time Ranges': '请输入时间',
    'StartDate': '开始日期',
    'EndDate': '结束日期',
    'Export': '导出',
    'Labor Billing Report-': '劳务账单报表 - ',
    'BillingReportTitle': '劳务账单报表',
    'Billing Date Range:': '时间区间',
    'Export PDF Report': '导出PDF报表',
    'SearchLaborName': '搜索劳务名称'
  },
  'product': {
    'TypeOfWork': 'Type of Work',
    'TotalQuantity': '总数',
    'Unit': '单位',
    'UnitCost': '价格',
    'ContractAmount': ' 总额',
    'BatchDelete': '批量删除',
    'CreatedTime': '创建时间',
    'Actions': '操作',
    'New': '创建',
    'Edit': '编辑',
    'Delete': '删除',
    'AreYouSureYouWantToDeleteThisProduct': '您确定要删除这个材料?',
    'TIPS': '提示',
    'Yes': '是',
    'No': '否',
    'PleaseCheckOneProductAtLast': '请至少勾选一个材料',
    'AreYouSureYouWantToDeleteTheseProducts': '您确定要删除选中的材料?',
    'All': '全部',
    'SearchSKU': 'Search SKU'
  },
  'productDialog': {
    'Cancel': '取消',
    'Save': '保存',
    'AddProduct': '创建材料',
    'EditProduct': '编辑材料',
    'SKU': 'SKU/Name',
    'Caption': 'Caption',
    'ProductType': '类型',
    'Trade': 'Trade',
    'Color': '颜色',
    'Unit': '单位',
    'TotalQuantity': '总数',
    'Price': '单价',
    'SKUisrequired': 'SKU/Name is required',
    'Captionisrequired': 'Caption is required',
    'ProductTypeIsrequired': '请选择类型',
    'Unitisrequired': '请选择单位',
    'QuantityMustGreaterThan0': '数量必须大于0'
  },
  'markup': {
    'Start': '编辑',
    'Save': '保存'
  },
  ...zhlocale
}

export default cn
